module.exports = __webpack_public_path__ + "static/media/ic_head15.d580a4ee.png";